import { call, put, takeEvery } from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import * as constants from './constants';
import * as actions from './actions';

function* getBarcodeManufacturers() {
  try {
    const params = {
      query: {
        limit: 10000,
        page: 1,
        // name: action?.payload?.name ?? '',
      },
    };

    const { data } = yield call(request, API.BARCODE_MANUFACTURERS, 'GET', params);
    yield put(actions.getBarcodeManufacturersSuccess(data));
  } catch (e) {
    yield put(actions.getBarcodeManufacturerssError(e));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getBarcodeManufacturersWatcher() {
  yield takeEvery(constants.GET_BARCODE_MANUFACTURERS, getBarcodeManufacturers);
}
